// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wbc8","content":"ManualTimeModal_content__2bXNS"};